import { alpha } from "@mui/material";
import { grey, red } from "@mui/material/colors";

const styles = {
  mainContainer: {
    backgroundColor: "white",
    borderRadius: "1rem",
    width: "100%",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  title: {
    fontWeight: "bold",
  },
  dateContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "0px !important",
  },
  timelineContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "8px",
    padding: "8px 0",
  },
  statusText: {
    fontWeight: "600",
    marginBottom: "4px",
  },
  deliveryManContainer: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 10px",
    backgroundColor: alpha(grey[500], 0.1),
    borderRadius: "1.5rem",
    width: "fit-content",
  },
  deliveryManIconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    backgroundColor: alpha(grey[500], 0.1),
    borderRadius: "50%",
  },
  deliveryManIcon: {
    fontSize: "16px",
    color: grey[600],
  },
  icon: {
    fontSize: "16px",
    color: grey[600],
  },
  deliveryManText: {
    color: grey[700],
    fontWeight: "500",
  },
  reasonReturnContainer: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 10px",
    backgroundColor: alpha(red[500], 0.15),
    borderRadius: "1.5rem",
    width: "fit-content",
  },
  reasonReturnText: {
    color: red[700],
    fontWeight: "500",
  },
  evidenceContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginTop: "4px",
  },
  evidenceHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  evidenceDate: {
    color: grey[600],
    fontSize: "0.7rem",
  },
  imagesGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    maxWidth: "400px",
    justifyContent: "flex-end",
  },
  identificationImagesGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    maxWidth: "400px",
    justifyContent: "flex-end",
  },
  evidenceCard: {
    position: "relative",
    cursor: "pointer",
    borderRadius: "8px",
    overflow: "hidden",
    width: "100px",
    height: "100px",
    transition: "all 0.3s ease",
    boxShadow: `0 2px 8px ${alpha(grey[900], 0.1)}`,
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: `0 4px 12px ${alpha(grey[900], 0.15)}`,
    },
  },
  identificationCard: {
    position: "relative",
    cursor: "pointer",
    borderRadius: "8px",
    overflow: "hidden",
    width: "160px",
    height: "100px",
    transition: "all 0.3s ease",
    boxShadow: `0 2px 8px ${alpha(grey[900], 0.1)}`,
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: `0 4px 12px ${alpha(grey[900], 0.15)}`,
    },
  },
  noEvidenceContainer: {
    marginTop: "8px",
    padding: "8px 12px",
    backgroundColor: alpha(grey[500], 0.05),
    borderRadius: "8px",
    border: `1px dashed ${alpha(grey[500], 0.3)}`,
  },
  noEvidenceText: {
    color: grey[600],
    fontSize: "0.75rem",
    fontStyle: "italic",
  },
  mapButton: {
    marginTop: "8px",
    borderRadius: "0.5rem",
    height: "32px",
    fontSize: "0.75rem",
    color: red["A400"],
    borderColor: red["A400"],
    backgroundColor: red["50"],
    "&:hover": {
      borderColor: red["A700"],
      backgroundColor: red[100],
      color: red["A700"],
    },
  },
  mapContainer: {
    height: "60vh",
    width: "100%",
    borderRadius: "8px",
  },
  evidenceImage: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },
  imageOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: alpha(grey[900], 0.3),
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    alignItems: "center",
    justifyContent: "center",
    opacity: 0,
    transition: "opacity 0.3s ease",
    "&:hover": {
      opacity: 1,
    },
  },
  overlayIcon: {
    color: "white",
    fontSize: "24px",
  },
  evidenceLabel: {
    color: grey[700],
    fontSize: "0.75rem",
    fontWeight: "600",
  },
  fullImage: {
    width: "100%",
    height: "90%",
    maxHeight: "80vh",
    objectFit: "contain",
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 8,
    color: grey[500],
    "&:hover": {
      backgroundColor: alpha(grey[500], 0.1),
    },
  },
  dialogActions: {
    padding: "8px 24px 16px",
  },
  paymentItemContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: "100px",
  },
  paymentComment: {
    color: grey[700],
    fontSize: "0.7rem",
    lineHeight: "1.2",
    wordWrap: "break-word",
    maxWidth: "100px",
    textAlign: "left",
  },
};

export default styles;
